module.exports = __webpack_public_path__ + "img/keyboard_Arrow_Up.516628f5.png";